module.exports = __webpack_public_path__ + "static/logo-white-dfeb91e45b9dfd26af0cd1952198475e.png";